import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import Loading from 'components/Loading/Loading';
import './Overlay.scss';

export default class Overlay extends Component {
  static propTypes = {
    loadingState: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    loaderPosition: PropTypes.string,
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  render() {
    return (
      <div className="overlay">
        <div className="overlay__inner" />
        <Loading position={this.props.loaderPosition} loadingState={this.props.loadingState} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Overlay/Overlay.jsx
 **/